<script setup>

const { couleur } = defineProps({
    couleur: String
});

</script>

<template>
    <div class="pastille">
        <svg width="20" height="20">
            <polygon points="0,0 10,0 10,10 0,10" :fill="couleur" stroke="var(--couleur-bordure)"/>
        </svg>
    </div>
</template>

<style scoped>

.pastille {
    position: absolute;
    padding: 0px;
    top: 2px;
    left: 2px;
}

</style>